import { createRouter, createWebHistory} from 'vue-router';
import HomePage from './pages/HomePage.vue';
import BiographyPage from './pages/BiographyPage.vue';
import ContactPage from './pages/ContactPage.vue';
import ExhibitionPage from './pages/ExhibitionPage.vue';
import PortfolioPage from './pages/PortfolioPage.vue';
import ExhibitionEditPage from './pages/admin/ExhibitionEditPage.vue';
import PortfolioEditPage from './pages/admin/PortfolioEditPage.vue';
import BiographyEditPage from './pages/admin/BiographyEditPage.vue';
import LoginPage from './pages/admin/LoginPage.vue';

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            name: 'home',
            path: '/',
            component: HomePage,
        },
        {
            name: 'biography',
            path: '/bio',
            component: BiographyPage,
        },
        {
            name: 'contact',
            path: '/contact',
            component: ContactPage,
        },
        {
            name: 'exhibition',
            path: '/exhibition',
            component: ExhibitionPage,
        },
        {
            name: 'portfolio',
            path: '/portfolio',
            component: PortfolioPage,
        },
        {
            name: 'exhibition-edit',
            path: '/site-settings/exhibition-edit',
            component: ExhibitionEditPage,
        },
        {
            name: 'portfolio-edit',
            path: '/site-settings/portfolio-edit',
            component: PortfolioEditPage,
        },
        {
            name: 'biography-edit',
            path: '/site-settings/biography-edit',
            component: BiographyEditPage,
        },
        {
            name: 'login-page',
            path: '/site-settings',
            component: LoginPage
        }
    ]
});

export default router;